import { PensionCalculators, Dashboard, Menu, MenuChildren, OfficeDashboard, Tv } from "../Component";

export default [
    {
        path: "/",
        component: () => import("@/App/FD/Dashboard/Components/Home.vue"),
        name: "home",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/menu",
        component: Menu,
        name: "menu",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/tv",
        component: Tv,
        name: "tv",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/menu/:id/children",
        component: MenuChildren,
        name: "menu-children",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/pension-calculators",
        component: PensionCalculators,
        name: "PensionCalculators",
        meta: {
            requiresAuth: true,
        },
    },
];
